//引入部分
import Vue from 'vue'
import VueI18n from 'vue-i18n'
//引入element 自带的语言包
import elementEnLocale from 'element-ui/lib/locale/lang/en';
import elementZhLocale from 'element-ui/lib/locale/lang/zh-CN';
import locale from 'element-ui/lib/locale';
//引入自己创建的语言包
import enLocale from './en'
import zhLocale from './zh'

//注册i18n
Vue.use(VueI18n)
// 引入本地
const messages = {
    en: {
        ...enLocale, // es6的拓展运算符，相当于解析出每个对象
        ...elementEnLocale
    },
    zh: {
        ...zhLocale,
        ...elementZhLocale
    }
}
// 创建国际化实例
const i18n = new VueI18n({
    locale: window.sessionStorage.getItem('lang_IAP') || 'zh', // set locale，默认中文
    messages // set locale messages。语言包
})
locale.i18n((key, value) => i18n.t(key, value)) //重点：为了实现element插件的多语言切换
//暴露出去
export default i18n

